import { forwardRef } from "react";
import AutoCompleteOption from "./AutoCompleteOption";

const AutoCompleteOptions = forwardRef(function AutoCompleteOptions({ options, show, onSelect }, ref) {
  const selectNextOption = () => {
    const focusedElement = document.activeElement;
    if (focusedElement && focusedElement.nextSibling) {
      (focusedElement.nextSibling).focus();
    }
  }

  const selectPreviousOption = () => {
    const focusedElement = document.activeElement;
    if (focusedElement && focusedElement.previousSibling) {
      (focusedElement.previousSibling).focus();
    }
  }

  return (
    <div
      ref={ref}
      className={`m-0 border-x-2 border-b-2 rounded-lg ${show ? 'visible' : 'hidden'}`}
    >
      {options.map((option, index) => (
        <AutoCompleteOption
          key={option.id}
          index={index}
          option={option}
          onSelect={onSelect}
          selectNext={selectNextOption}
          selectPrevious={selectPreviousOption}
        />
      ))}
    </div>
  );
});

export default AutoCompleteOptions;
